import { Component, Host, h, Prop } from "@stencil/core";

import store from "../store";
import disableBot from "../../../disable-bot";
import { mesosConfig } from "../../../config/mesos-config";
import { LS_BOT_TOGGLE_BUTTON } from "../../../global/variables";

@Component({
    tag: "leichte-sprache-toggle",
    styleUrl: "leichte-sprache-toggle.scss",
    shadow: true,
})
export class LeichteSpracheToggle {
    store = store;
    buttonElement: HTMLButtonElement | undefined;
    @Prop() screenReader: string = LS_BOT_TOGGLE_BUTTON;

    constructor() {
        this.store.onClose(() => {
            const openedBy = this.store.wasOpenedBy();
            if (openedBy) {
                openedBy.focus();
            }
        });
    }

    handleClick() {
        this.store.isOpen()
            ? this.store.closeChatbot()
            : this.store.openChatbot(this.buttonElement);
    }

    render() {
        return (
            <Host
                hidden={disableBot(
                    mesosConfig,
                    window.location.host,
                    window.location.pathname
                )}
            >
                <button
                    title={this.screenReader}
                    aria-label={this.screenReader}
                    aria-expanded={this.store.isOpen() ? "true" : "false"}
                    aria-haspopup="dialog"
                    aria-controls="ls-digitaler-assistent"
                    onClick={this.handleClick.bind(this)}
                    ref={(el) => (this.buttonElement = el)}
                >
                    <slot></slot>
                </button>
            </Host>
        );
    }
}
